import React from 'react';

import { AskAi } from '@lumapps/ask-ai/components/AskAi/AskAi';

import { LumappsComponentType } from '../../constants';
import type { LumappsComponentProps } from '../../types';
import type { AskAiComponentParameters } from './types';

export interface AskAnswerComponentProps
    extends LumappsComponentProps<LumappsComponentType.AskAnswer, AskAiComponentParameters> {}

/**
 * AskAi component that let the user previews the answer from Ask
 * @param AskAnswerComponentProps
 * @returns AskAnswerComponent
 */
export const AskAnswerComponent: React.FC<AskAnswerComponentProps> = ({ componentProperties, inputVariables }) => {
    const { settings: componentSettings } = componentProperties;

    const inputQuery = inputVariables?.query;
    const query = inputQuery && typeof inputQuery === 'string' ? inputQuery : 'test-query';

    return (
        <AskAi
            isPreview
            query={query}
            traceId="is-run-in-builder"
            bestAnswer={{ answer: componentSettings?.answer, query, sources: componentSettings?.sources }}
        />
    );
};
